import React from "react";
import "./index.scss";

export const CustomDragPreview = ({ monitorProps }) => {
  return (
    <div className={"CustomDragPreview"}>
      <div className={"label"}>{monitorProps.item.text}</div>
    </div>
  );
};
